import { useState, useEffect } from "react";
import RotateNormal from "./Geometry/RotateNormal";
import { findBoundsOfArrayOfItems } from "../../refractCommon/miro/findBoundsOfArrayOfItems";
import FlipGroup from "./Geometry/FlipGroup";
import Scale from "./Geometry/Scale";
import Circle from "./Geometry/Circle";
import ComingSoonDivider from "../PowerPack_Common/ComingSoonDivider";
import ScaleGradient from "./Geometry/ScaleGradient";
import { sortLeftRightTopBottom } from "../../refractCommon/miro/sortLeftRightTopBottom";

const { board } = window.miro;

export default function GeometryTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  const [circleItems, setCircleItems] = useState([]);

  useEffect(() => {
    runSelectItemsForCircle(boardSelection);
  }, [boardSelection]);

  // C I R C L E
  // CIRCLE TOOL APPLICABLE ITEM TEYMES
  async function runSelectItemsForCircle(selection) {
    if (!selection) {
      return [];
    }
    if (selection.length === 0) {
      setCircleItems(selection);
      return selection;
    }
    if (selection.length > 0) {
      let reorderedList = await sortLeftRightTopBottom(selection);
      let filteredSelection = reorderedList.filter(
        (item) =>
          (item.type === "sticky_note" && item.parentId === null) ||
          (item.type === "text" && item.parentId === null) ||
          (item.type === "card" && item.parentId === null) ||
          (item.type === "shape" && item.parentId === null) ||
          (item.type === "frame" && item.childrenIds.length === 0) ||
          (item.type === "image" && item.parentId === null)
      );

      setCircleItems(filteredSelection);
      return filteredSelection;
    }
  }
  // THE CIRCLE ITEM TYPE ICONS TO MATCH
  let circleItemTypeIcons = (
    <div className="cs4 ce12 grid mt--8">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-frame cs4"></div>
      <div className="m2 icon icon-text cs5"></div>
      <div className="m2 icon icon-image cs6"></div>
    </div>
  );

  async function runCircle() {
    // GAURD CLAUSES
    // we don't have a selection set
    if (boardSelection.length === 0) {
      return;
    }
    // our item count is too small to be worth making a circle
    if (circleItems.length < 3) {
      return;
    }

    // LETS MAKE THAT CIRCLE
    // maybe we find a bounds and a centroid
    // then use that centroid as center
    // then larger of width or height * 0.5 as radius
    let selection = await board.getSelection();
    let filteredSelection = await runSelectItemsForCircle(selection);

    let boardSelectionBounds = findBoundsOfArrayOfItems(filteredSelection);
    let circleCenterX = boardSelectionBounds.centroidX;
    let circleCenterY = boardSelectionBounds.centroidY;

    let circleRadius =
      Math.max(boardSelectionBounds.width, boardSelectionBounds.height) * 0.5;

    // then run the point-finding algorithm
    let theta = (Math.PI * 2) / filteredSelection.length;

    filteredSelection.forEach((item, index) => {
      let currentAngle = theta * index;
      item.x = circleCenterX + circleRadius * Math.sin(currentAngle);
      item.y = circleCenterY - circleRadius * Math.cos(currentAngle);
      item.sync();
    });
  }

  // findGeomCenter (center of bounds)
  // findCentroid (weighted center)

  return (
    <div className="div">
      <div className="help-container warning-help cs1 ce12  ">
        <p className="p-medium mt-0 mb-0">
          <b>Note:</b> &nbsp; At this point Geometry tools do not respect
          'grouped' items nor can they be applied to items in a frame or frames
          with items. Apply these tools to ungrouped & unframed items or empty
          frames.
        </p>
      </div>

      <Scale boardSelection={boardSelection} />

      <Circle boardSelection={boardSelection} />

      <RotateNormal boardSelection={boardSelection} />

      <FlipGroup boardSelection={boardSelection} />

      <ScaleGradient boardSelection={boardSelection} />

      <ComingSoonDivider visible={true} />

      <div className="tool-section grid  pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="icon m2 icon-collapse cs1"></div>
        <h3 className="h3 cs2 ce12 mt-0 mb-0">Pull items inward</h3>{" "}
        <p className="p-medium mt-0 mb-0 cs1 ce12"> In toward their center</p>
      </div>
      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="icon m2 icon-drag cs1"></div>
        <h3 className="h3 cs2 ce12 mt-0 pb-0 mb-0">Push items outward</h3>
        <p className="p-medium mt-0 mb-0 pt-0 cs1 ce12">
          Away from their center
        </p>
      </div>
      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="icon m2 icon-fit cs1"></div>
        <h3 className="h3 cs2 ce12 mt-0 pb-0 mb-0">
          Make Same Height or Width
        </h3>
        <p className="p-medium mt-0 mb-0 pt-0 cs1 ce12">
          Scale items to match a target height.
        </p>
      </div>
      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="icon m2 icon-refresh cs1"></div>
        <h3 className="h3 cs2 ce12 mt-0 pb-0 mb-0">
          Arrange in Spiral or Wave
        </h3>
        <p className="p-medium mt-0 mb-0 pt-0 cs1 ce12">
          Layout in spiral or wave pattern.
        </p>
      </div>
      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="cs1 icon m2 icon-arrow-line-shape"></div>
        <h3 className="h3 cs2 ce12 mt-0 pb-0 mb-0">Space Along Chosen Line</h3>
        <p className="p-medium mt-0 mb-0 pt-0 cs1 ce12">
          Layout items along the pathway of a chosen line.
        </p>
      </div>
      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch">
          {/* <span className="p-small coming-soon">Coming Soon</span> */}
        </div>
        <div className="cs1 icon m2 icon-arrow-line-shape"></div>
        <h3 className="h3 cs2 ce12 mt-0 pb-0 mb-0">
          Rotate, but Maintain Orientation
        </h3>
        <p className="p-medium mt-0 mb-0 pt-0 cs1 ce12">
          Rotate a selection by a given angle but have all items in selection
          retain their original orientation.
        </p>
      </div>
    </div>
  );
}
